import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, TButton } from '@/shared/ui/lib/Button';

import { useLogout } from '../model/useLogout';

type TLogoutButtonProps = TButton;
export const LogoutButton = ({ ...props }: TLogoutButtonProps) => {
  const { t } = useTranslation();
  const { logout } = useLogout();

  return (
    <Button color="error" variant="outlined" onClick={logout} {...props}>
      {t('common:header.userMenu.logout')}
    </Button>
  );
};
